// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.login {
  height: 100vh;
  width: 100%;
  display: flex;
}
.login-form {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  width: 440px;
  max-width: calc(100vw - 32px);
  margin: auto;
  padding: 28px;
  position: relative;
}
.login-form * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .login-form {
    animation: none;
  }
}
.login-form--content {
  display: flex;
  flex-direction: column;
  gap: 18px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
}
.login-form--content_header {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin: 0;
  text-align: left;
}
.login-form--content_social {
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  margin: 0;
}
.login-form--content_social__link {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  flex: 1;
  height: 52px;
  display: flex;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease;
}
.login-form--content_social__link img {
  width: auto;
  max-width: 70%;
  height: 28px;
  margin: auto;
  opacity: 0.8;
}
.login-form--content_social__link:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: var(--gold-dark);
}
.login-form--content_social__link:hover img {
  opacity: 1;
}
.login-form--content_social__link:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.login-form--content_main {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
  margin: 0;
}
.login-form--content_main .skymp-input {
  width: 100%;
  align-self: stretch;
}
.login-form--content_main__email, .login-form--content_main__password {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 6px;
  margin: 0;
}
.login-form--content_main__footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin: 0;
}
.login-form--content_main__button {
  margin: 6px 0 0;
}
.login-form--content_main__button button, .login-form--content_main__button .skymp-button {
  width: 100%;
}
.login-form--content_main__label {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: auto;
}
.login-form--content_main__label img {
  display: none;
}
.login-form--content_main__label___text {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  margin: 0;
}
.login-form--content_main__label label {
  margin: 0;
}

.login-form--content_social__link {
  cursor: pointer;
}

.skymp-input.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  padding: 5px 10px;
  font-size: 13px;
  width: auto;
  height: auto;
  border-width: 1px;
}
.skymp-input.button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.skymp-input.button:active:not(:disabled) {
  transform: translateY(1px);
}
.skymp-input.button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.skymp-input.button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.skymp-input.button:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.skymp-input.button.disabled {
  opacity: 1;
}
.skymp-input.button.disabled * {
  opacity: 1;
}
.skymp-input.button .skymp-input_text {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 1.2;
  color: inherit;
  margin: 0;
}

.checkbox {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease;
}
.checkbox:hover {
  border-color: var(--gold-dark);
}
.checkbox::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 2px;
  width: 6px;
  height: 11px;
  border-right: 2px solid #14100a;
  border-bottom: 2px solid #14100a;
  transform: rotate(45deg);
  opacity: 0;
}
.checkbox.active {
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.checkbox.active::after {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/login/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAPA;EACE,aAAA;EACA,WAAA;EACA,aAAA;AASF;AAPE;ED0BA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;ECpKE,YAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAeJ;ADME;EAAI,sBAAA;ACHN;ADgJE;ECzKA;IDyK0C,eAAA;EC5I1C;AACF;AArBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yDDUM;ECTN,cAAA;AAuBN;AArBM;EDiCJ,kDA3BW;EA4BX,gBAAA;EACA,eClCyB;EDmCzB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECIC,SAAA;EACA,gBAAA;AA4BR;AAzBM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;AA2BR;AAzBQ;EDcN,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;ECYC,OAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gEAAA;AA6BV;AA3BU;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AA6BZ;AA1BU;EAAU,qCAAA;EAAuC,8BAAA;AA8B3D;AA7BU;EAAc,UAAA;AAgCxB;AA/BU;EAAkB,oCAAA;EAAsC,mBAAA;AAmClE;AA/BM;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,SAAA;AAiCR;AA/BQ;EACE,WAAA;EACA,mBAAA;AAiCV;AA9BQ;EAEE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;AA+BV;AA5BQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;AA8BV;AA3BQ;EACE,eAAA;AA6BV;AA3BU;EAAwB,WAAA;AA8BlC;AA3BQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AA6BV;AA1BU;EAAM,aAAA;AA6BhB;AA3BU;ED5BR,eAAA;EACA,gBAAA;EACA,cAzDO;ECqFG,SAAA;AA+BZ;AA5BU;EAAQ,SAAA;AA+BlB;;AAxBA;EACE,eAAA;AA2BF;;AAvBA;EDtCE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAyBA,cArGO;EAsGP,uBAAA;EACA,yBAAA;EAMA,iBAAA;EACA,eAAA;ECPA,WAAA;EACA,YAAA;EACA,iBAAA;AA4CF;ADvEE;EAAyB,qCAAA;EAAuC,8BAAA;AC2ElE;AD1EE;EAA0B,0BAAA;AC6E5B;AD5EE;EAAa,YAAA;EAAc,mBAAA;ACgF7B;AD/EE;EAAkB,oCAAA;EAAsC,mBAAA;ACmF1D;AD3DE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACgEhF;AA9DE;EACE,UAAA;AAgEJ;AA/DI;EAAI,UAAA;AAkER;AA/DE;EACE,yDD1GQ;EC2GR,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAiEJ;;AA5DA;EACE,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,+BDxIU;ECyIV,0CAAA;EACA,kBAAA;EACA,eAAA;EACA,gEAAA;AA+DF;AA7DE;EAAU,8BAAA;AAgEZ;AA9DE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,+BAAA;EACA,gCAAA;EACA,wBAAA;EACA,UAAA;AAgEJ;AA7DE;EACE,4BAAA;EACA,8BAAA;AA+DJ;AA7DI;EAAW,UAAA;AAgEf","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n.login {\n  height: 100vh;\n  width: 100%;\n  display: flex;\n\n  &-form {\n    @include ink.panel;\n    @include ink.enter;\n    width: 440px;\n    max-width: calc(100vw - 32px);\n    margin: auto;\n    padding: 28px;\n    position: relative;\n\n    &--content {\n      display: flex;\n      flex-direction: column;\n      gap: 18px;\n      font-family: ink.$font-text;\n      color: ink.$text;\n\n      &_header {\n        @include ink.title(26px);\n        margin: 0;\n        text-align: left;\n      }\n\n      &_social {\n        display: flex;\n        flex-direction: row;\n        gap: 10px;\n        width: 100%;\n        margin: 0;\n\n        &__link {\n          @include ink.block;\n          flex: 1;\n          height: 52px;\n          display: flex;\n          cursor: pointer;\n          transition: background-color 0.12s ease, border-color 0.12s ease;\n\n          img {\n            width: auto;\n            max-width: 70%;\n            height: 28px;\n            margin: auto;\n            opacity: 0.8;\n          }\n\n          &:hover { background: rgba(255, 255, 255, 0.08); border-color: var(--gold-dark); }\n          &:hover img { opacity: 1; }\n          &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n        }\n      }\n\n      &_main {\n        display: flex;\n        flex-direction: column;\n        align-items: stretch;\n        gap: 14px;\n        margin: 0;\n\n        .skymp-input {\n          width: 100%;\n          align-self: stretch;\n        }\n\n        &__email,\n        &__password {\n          display: flex;\n          flex-direction: column;\n          width: 100%;\n          gap: 6px;\n          margin: 0;\n        }\n\n        &__footer {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          justify-content: space-between;\n          gap: 12px;\n          width: 100%;\n          margin: 0;\n        }\n\n        &__button {\n          margin: 6px 0 0;\n\n          button, .skymp-button { width: 100%; }\n        }\n\n        &__label {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          gap: 10px;\n          width: auto;\n\n          // Decorative icons next to the labels are not part of the new look.\n          img { display: none; }\n\n          &___text {\n            @include ink.label;\n            margin: 0;\n          }\n\n          label { margin: 0; }\n        }\n      }\n    }\n  }\n}\n\n.login-form--content_social__link {\n  cursor: pointer;\n}\n\n// \"Register\" link sitting next to the remember checkbox: quiet tertiary action.\n.skymp-input.button {\n  @include ink.button;\n  @include ink.button-quiet;\n  @include ink.button-sm;\n  width: auto;\n  height: auto;\n  border-width: 1px;\n\n  &.disabled {\n    opacity: 1;\n    * { opacity: 1; }\n  }\n\n  .skymp-input_text {\n    font-family: ink.$font-text;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 1.2;\n    color: inherit;\n    margin: 0;\n  }\n}\n\n// Check box used by the login form and the generic checkbox component.\n.checkbox {\n  position: relative;\n  display: inline-block;\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  box-sizing: border-box;\n  background: ink.$ink-field;\n  border: 1px solid ink.$line-strong;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease;\n\n  &:hover { border-color: var(--gold-dark); }\n\n  &::after {\n    content: '';\n    position: absolute;\n    left: 6px;\n    top: 2px;\n    width: 6px;\n    height: 11px;\n    border-right: 2px solid ink.$on-accent;\n    border-bottom: 2px solid ink.$on-accent;\n    transform: rotate(45deg);\n    opacity: 0;\n  }\n\n  &.active {\n    background: var(--gold-main);\n    border-color: var(--gold-main);\n\n    &::after { opacity: 1; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
